import React from 'react';

const LayoutReview = ({ children, className, id = 'layout-review' }) => {
  return (
    <main id={id} className={`max-w-review w-full bg-white py-6 px-8 ${className || ''}`}>
      {children}
    </main>
  );
};

export default React.memo(LayoutReview);
